import React, { useEffect, useState } from "react";
import { Grid, Typography, Slider } from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import Skeleton from "@material-ui/lab/Skeleton";
import {useTranslation} from 'react-i18next';
import moment from "moment";
import { quickpayService } from "../model/balanceService";

const useStyle = makeStyles((theme) => ({
  mainPadding: {
    // padding: "4%",
  },
  whiteColorFont: {
    color: theme.palette.eWhite?.base +" !important",
    textAlign:'center'
  },
  prepaidDetailContainer: {
    flexFlow: "nowrap"
  },
  avgCostStyling: {
    fontSize: "0.7rem !important",
    color: theme.palette.eWhite?.base +" !important",
  },
  centerAlign:{
    display: "flex",
    justifyContent: "space-around",
  }
}));
const PrettoSlider = withStyles((theme) => ({
  root: {
    color: theme.palette.eTertiary?.base,
    height: 10,
  },
  thumb: {
    height: 30,
    width: 24,
    color: theme.palette.eTertiary?.base,
    background: "transparent",
    marginTop: -8,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    center: "calc(-50% + 4px)",
    top: -22,
    "& *": {
      background: "transparent",
    },
  },
  track: {
    height: 13,
    borderRadius: 4,
    color: theme.palette.eTertiary?.base,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
  mark: {
    width: 0
  },
  markLabel: {
    color: theme.palette.eWhite?.base,
    transform:'translateX(-100%)',
    '&[data-index="0"]' : {
      transform:'none'
    },
  },
}))(Slider);
export default function E_Amount({setLatestAmt,setlatestDate}) {
  const {t:content} = useTranslation("content-E_PREPAID_ACCOUNTSUMMARY");
  const { t: labels, ready: labelReady } = useTranslation(
    "label-E_PREPAID_ACCOUNTSUMMARY"
  );
  let dateFormat = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.E_DATE_MONTH_YEAR_FORMAT
  );
  let classes = useStyle();
  let [maxAmount, setMaxAmount] = useState();
  let [daysLeft, setDaysLeft] = useState();
  let [avgCost, setAvgCost] = useState();
  let [date,setDate] = useState()
  const [amt, setamt] = useState()
  const EDGE_CURRENCY_SYMBOL= "BDT";
  let uniqueId = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.PRIMARY_IDENTIFIER
  );
  const {customerNumber} = useSelector((state) => state.meterDetails)
  const [currencySymbol, setCurrencySymbol] = useState();
  let saDetails = useSelector((store) => store?.meterDetails?.getSaInfo);
  let curSymbol = useSelector((state) => state?.meterDetails?.curSymbol);
  const parameter = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup
  );
  let interval = parameter?.E_BALANCE_REFRESH
  let interValPeriod=Number(interval)?Number(interval):60

  let minAmount = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.PREPAID_MINIMUM_TOPUP_AMOUNT
  );
  let currencyCode = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.E_CURRENCY_CODE
  );
  useEffect(() => {
    if(curSymbol) {
      setCurrencySymbol(curSymbol && curSymbol==EDGE_CURRENCY_SYMBOL?currencyCode:curSymbol);
    }
  }, [curSymbol])
  useEffect(() => {
    setMaxAmount(saDetails?.prepaidSaDetail?.lastPayAmtOnSa ? saDetails?.prepaidSaDetail?.lastPayAmtOnSa : 0);
  }, [saDetails]);
  const marks = [
    {
      value: minAmount,
      label: `${currencySymbol} ${minAmount}`,
    },
    {
      value: maxAmount,
      label: maxAmount ? `${currencySymbol} ${maxAmount}` : "",
    },
  ];
  // useEffect(()=>{
  //   let time=saDetails?.balanceLatestDate.slice(11)
  //   time = time.split(".")
  //   time = time.join(":")
  //   let date = saDetails?.balanceLatestDate.slice(0,10)
  //   let dateTime =date+" "+time;
  //   let latestDate = moment(dateTime).format('lll')
  //   setDate(latestDate)
  // },[saDetails])


  const fetchBalance=()=>{
    let acc = localStorage.getItem("accountSelected")
    if(acc){
      quickpayService.postbalance(uniqueId,acc).then((res)=>{
        setamt(res?.data.postBalanceDetails?.balanceRemaining)
        let time=res?.data?.postBalanceDetails?.balanceLatestDate.slice(11)
      time = time.split(".")
      time = time.join(":")
      let date = res?.data?.postBalanceDetails.balanceLatestDate.slice(0,10)
      let dateTime =date+" "+time;
      let latestDate = moment(dateTime).format('lll')
      setDate(latestDate)
      let lastRechargeDate =moment(date).format(dateFormat) 
      setlatestDate(res?.data.postBalanceDetails?.lastPayDateOnSa)
      setLatestAmt(res?.data.postBalanceDetails?.lastPayAmtOnSa)
      }).catch(err=>{
        console.log(err,"Error fetching the data")
      })
    }
    
  }
  useEffect(()=>{
    fetchBalance();
  },[customerNumber])

  useEffect(() => {
   const intervalId = setInterval(() => {
        fetchBalance()
    }, interValPeriod*1000)
    return () => {
      clearInterval(intervalId);
    };
  }, []);


  let balanceText = labels("E_PREPAID_TEXT")
  balanceText = balanceText.replace("****",date)

  return (
    <Grid container spacing={0} className={classes.mainPadding}>
      <Grid item xs={12}>
        <Grid container  className={[classes.prepaidDetailContainer,classes.centerAlign]}>
          {amt ? (
            <Grid item>
              {balanceText && <Typography variant="body2" className={classes.whiteColorFont} >
              {labels("E_PREPAID_TEXT")} <br/>
              {date} {labels("E_PREPAID_IS")}
              </Typography>}
              {amt && <Typography style={{textAlign: 'center',fontSize: '2rem'}} className={classes.whiteColorFont}>{currencySymbol + " " + amt}</Typography>}
            </Grid>
          ) : (
            <Skeleton sx={{ bgcolor: 'white' }} />
          )}
      </Grid>
      </Grid>
    </Grid>
  );
}
